import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { Grid, Stack } from '@mui/material';

import { IcInfoCircle } from '@/assets/images';
import { FormCard, FormRoot, RenderFormField, SelectItem } from '@/components';
import { CallerInformation } from '@/components/CustomForms/ReporterForm/CallerInformationForm';
import { ICFSForm } from '@/models';
import { colors } from '@/theme/variables';

import { CFSFormFields, cfs, formValues } from '../data';

export type OptionType = {
  label: string;
  value: string;
  disabled?: boolean;
};

export const CFSForm = () => {
  const { reset } = useFormContext<Partial<ICFSForm>>();

  useEffect(() => {
    reset(formValues as any);
  }, []);

  const getFormFieldItems = (fieldName: string): SelectItem[] | undefined => {
    if (fieldName === 'incidentCodes') {
      return [
        { label: '104', value: '104' },
        { label: '111', value: '111' },
      ];
    }

    if (fieldName === 'assignedAgencies') {
      return [
        { label: 'Agency name 01', value: 'Agency name 01' },
        { label: 'Agency name 02', value: 'Agency name 02' },
      ];
    }

    return undefined;
  };

  return (
    <>
      <FormRoot onBlur={() => {}} sx={{ mt: '2px', pb: 0 }}>
        {CFSFormFields.map(({ title, name, items }) => (
          <FormCard key={title} title={title}>
            {items.map(({ styles, ...rest }) => (
              <Grid
                key={`${name}-${rest.name}`}
                {...{
                  ...styles,
                  marginRight: 5,
                }}
                item
              >
                <RenderFormField
                  {...rest}
                  name={name ? `${name}.${rest.name}` : rest.name}
                  items={getFormFieldItems(rest.name)}
                  emptyContent={
                    rest.name === 'assignedAgencies' ? (
                      <Stack
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '5px',
                        }}
                      >
                        <IcInfoCircle
                          style={{
                            marginRight: 6,
                            color: colors.error.main,
                          }}
                        />{' '}
                        <span>Unable to Dispatch, No Assigned Agencies</span>
                      </Stack>
                    ) : undefined
                  }
                  locationRestriction={undefined}
                  onChipDelete={() => {}}
                  pendingAddress=""
                  showMileMarkerOption={true}
                  overrideUpdateAddress={undefined}
                  handleChange={() => {}}
                />
              </Grid>
            ))}
          </FormCard>
        ))}
        <CallerInformation
          showRapidSOSIcon={false}
          callerInformation={cfs.number}
          reportTime={cfs?.reporter.reportTime}
          handleChangeReporterTime={async () => {}}
          organizationName=""
          calls={cfs?.calls}
        />
      </FormRoot>
    </>
  );
};
